webpackJsonp([119738742718559],{

/***/ 1591:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateProviderTransferInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"departmentId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"startTime","type":{"kind":"SCALAR","name":"DateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-update-provider-transfer-input-9bd2a53c472b7811535d.js